import { render } from "./BattlesCreateFilters.vue?vue&type=template&id=ca6894fa&scoped=true"
import script from "./BattlesCreateFilters.vue?vue&type=script&lang=js"
export * from "./BattlesCreateFilters.vue?vue&type=script&lang=js"

import "./BattlesCreateFilters.vue?vue&type=style&index=0&id=ca6894fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca6894fa"]])

export default __exports__